import Quickview from './Quickview'

export default {
  Quickview
}



// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetail/theme/components/quickview/index.js